import { OrgThemedButton } from 'components/OrgThemedButton';
import { INPUT_BORDER_RADIUS } from 'embed/constants';
import { Box } from '@mui/material';
import { useAppDispatch } from 'hooks';
import { endLiveChat } from 'actions/live-chat';

export const RestartChatButton = () => {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ boxSizing: 'border-box', width: '100%' }}>
      <OrgThemedButton
        fullWidth
        onClick={() => {
          dispatch(
            endLiveChat({
              /**
               * We don't want to send "User left the chat" message because it should've been
               * sent already when the end user ended the chat
               */
              shouldSendUserLeftMessage: false,
            }),
          );
        }}
        sx={{
          borderRadius: INPUT_BORDER_RADIUS,
        }}
        variant='contained'
      >
        Start new chat
      </OrgThemedButton>
    </Box>
  );
};
